import React from "react";

import "./Button.css";

function Button({ title = "", path = "/", isClickMode, handleClick = null, disabled=false }) {
  if (isClickMode) {
    return (
      <button className="btn" onClick={handleClick} disabled={disabled}>
        {title}
      </button>
    );
  }
  return (
    <a className="btn" href={path}>
      {title}
    </a>
  );
}

export default Button;
